.formFooter {
  padding: 10px 0;
  color: var(--text-secondary);

  &.centered {
    text-align: center;
  }

  a {
    font-size: inherit;
  }
}
